<section class="content-header" *ngIf="Evaluation != null && Subject != null">
  <h1>
    {{ Subject.nom }} {{ Subject.prenom }}
  </h1>
  <h6 *ngIf="Evaluation.typeTest === 1"><span i18n="@@expressTestOf">Express test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>
  <h6 *ngIf="Evaluation.typeTest === 2"><span i18n="@@classicTestOf">Classic test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>
  <h6 *ngIf="Evaluation.typeTest === 3"><span i18n="@@flashTestOf">Flash test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>
  <h6 *ngIf="Evaluation.typeTest === 4"><span i18n="@@normalTestOf">Normal test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>
  <h6 *ngIf="Evaluation.typeTest === 5"><span i18n="@@sevenFrequenciesTestOf">7 frequencies test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>
  <h6 *ngIf="Evaluation.typeTest === 6"><span i18n="@@fitcheckTestOf">Fitcheck test of</span> {{ Evaluation.dateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at">at</span> {{ Evaluation.heureDebut | date: 'HH:mm' }}</h6>

  <ol class="breadcrumb">
    <li><a i18n="@@CAPA">CAPA</a></li>
    <li i18n="@@results">Results</li>
    <li *ngIf="Evaluation != null">{{ Subject.nom }} {{ Subject.prenom }}</li>
  </ol>
</section>
<br />
<section class="content" *ngIf="Evaluation != null && Subject != null && Country != null && ParametreMO != null">
  <div class="row">
    <div class="col-sm-12">
      <div class="box box-capa">
        <div class="box-header">
          <div class="box-title">
            <h4 i18n="@@resultViewFirstBlockTitle">Estimation of the attenuation and conformity of the protectors</h4>
          </div>
        </div>
        <div class="box-body">
          <div class="row">


 <!------------------ MOBILE LAYOUT ------------------------>
            <div class="mobile-layout">
              <!--------- LEFT EAR --------->
              <div class="row" style="padding: 0 10% 0 10%">
                <div class="row">
                  <div class="col-xs-12">
                    <img *ngIf="Evaluation.conformeG === true" class="img-capa" src="assets/images/CAPA_Approved@dpi160.png" alt="Capa pprouved">
                    <img *ngIf="Evaluation.conformeG === false" class="img-capa" src="assets/images/CAPA_Rejected@dpi160.png" alt="Capa rejected">
                    <div class="centered">
                      <p i18n="@@estimated" style="margin: 0">ESTIMATED</p>
                      <strong>{{ Evaluation.psnaG }} dB</strong>
                      <p>{{ PAR }}</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <table style="width: 100%" aria-describedby="Reference of the measured protector">
                      <caption class="hidden"></caption>
                      <thead class="hidden">
                        <tr>
                          <th scope="hidden"></th>
                        </tr>
                      </thead>
                      <tr>
                        <td i18n="@@protectionReference">Reference of the measured protector</td>
                        <td>{{ Evaluation.picbG }}</td>
                      </tr>
                      <tr>
                        <td i18n="@@declared">This protector is declared</td>
                        <td *ngIf="Evaluation.conformeG === true" style="color: green" i18n="@@approved">Approved</td>
                        <td *ngIf="Evaluation.conformeG === false" style="color: red" i18n="@@rejected">Rejected</td>
                      </tr>
                      <tr>
                        <td><span i18n="@@estimatedLoss">Estimated attenuation</span> ({{ PAR }})</td>
                        <td>{{ Evaluation.psnaG }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="@@certifiedLoss">Certified attenuation (SNR)</td>
                        <td>{{ ParametreMO.snr }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="@@maximumExposureLevel">Maximum exposure level</td>
                        <td>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="overprotectionRisk">Overprotection risk</td>
                        <td *ngIf="Evaluation.psnaG > ParametreMO.snr + 8" i18n="@@yes">Yes</td>
                        <td *ngIf="Evaluation.psnaG <= ParametreMO.snr + 8" i18n="@@no">No</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <!--------- RIGHT EAR --------->
              <div class="row" style="padding: 0 10% 0 10%">
                <div class="row">
                  <div class="col-xs-12">
                    <img *ngIf="Evaluation.conformeD === true" class="img-capa" src="assets/images/CAPA_Approved@dpi160.png">
                    <img *ngIf="Evaluation.conformeD === false" class="img-capa" src="assets/images/CAPA_Rejected@dpi160.png">
                    <div class="centered">
                      <p i18n="@@estimated" style="margin: 0">ESTIMATED</p>
                      <b>{{ Evaluation.psnaD }} dB</b>
                      <p>{{ PAR }}</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <table style="width: 100%">
                      <tr>
                        <td i18n="@@protectionReference">Reference of the measured protector</td>
                        <td>{{ Evaluation.picbD }}</td>
                      </tr>
                      <tr>
                        <td i18n="@@declared">This protector is declared</td>
                        <td *ngIf="Evaluation.conformeD === true" style="color: green" i18n="@@approved">Approved</td>
                        <td *ngIf="Evaluation.conformeD === false" style="color: red" i18n="@@rejected">Rejected</td>
                      </tr>
                      <tr>
                        <td><span i18n="@@estimatedLoss">Estimated attenuation</span> ({{ PAR }})</td>
                        <td>{{ Evaluation.psnaD }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="@@certifiedLoss">Certified attenuation (SNR)</td>
                        <td>{{ ParametreMO.snr }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="@@maximumExposureLevel">Maximum exposure level</td>
                        <td>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</td>
                      </tr>
                      <tr>
                        <td i18n="@@overprotectionRisk">Overprotection risk</td>
                        <td *ngIf="Evaluation.psnaD > ParametreMO.snr + 8" i18n="@@yes">Yes</td>
                        <td *ngIf="Evaluation.psnaD <= ParametreMO.snr + 8" i18n="@@no">No</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
                <!---------- MAX EXPOSURE ----------->
                <div class="row">
                  <img class="img-capa" src="assets/images/CAPA_MaxExposureMeter3@dpi160.png">
                  <div class="centered" style="top: 87.5%">
                    <p i18n="@@maximum" style="margin: 0">MAXIMUM</p>
                    <b>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</b>
                    <p i18n="@@exposure">EXPOSURE</p>
                  </div>
                </div>
              </div>
 <!------------------ END MOBILE LAYOUT --------------------->



 <!------------------ DESKTOP LAYOUT ------------------------>
            <div class="desktop-layout">
              <div class="col-sm-4">
                <img *ngIf="Evaluation.conformeG === true" class="img-capa" src="assets/images/CAPA_Approved@dpi160.png">
                <img *ngIf="Evaluation.conformeG === false" class="img-capa" src="assets/images/CAPA_Rejected@dpi160.png">
                <div class="centered">
                  <p i18n="@@estimated" style="margin: 0;">ESTIMATED</p>
                  <b>{{ Evaluation.psnaG }} dB</b>
                  <p>{{ PAR }}</p>
                </div>
                <div class="row">
                  <div style="text-align: center">
                    <p>{{ Evaluation.picbG }}</p>
                    <p *ngIf="Evaluation.conformeG === true" style="color: green" i18n="@@approved">Approved</p>
                    <p *ngIf="Evaluation.conformeG === false" style="color: red" i18n="@@rejected">Rejected</p>
                    <p>{{ Evaluation.psnaG }} dB</p>
                    <p>{{ ParametreMO.snr }} dB</p>
                    <p>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</p>
                    <p>{{ Evaluation.psnaG > ParametreMO.snr + 8 ? 'Oui' : 'Non' }}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <img class="img-capa" src="assets/images/CAPA_MaxExposureMeter3@dpi160.png">
                <div class="centered">
                  <p i18n="@@maximum" style="margin: 0">MAXIMUM</p>
                  <b>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</b>
                  <p i18n="@@exposure">EXPOSURE</p>
                </div>
                <div class="row">
                  <div style="text-align: center">
                    <p i18n="@@protectionReference">Reference of the measured protector</p>
                    <p i18n="@@declared">This protector is declared</p>
                    <p><span i18n="@@estimatedLoss">Estimated attenuation</span> ({{ PAR }})</p>
                    <p i18n="@@certifiedLoss">Certified attenuation (SNR)</p>
                    <p i18n="@@maximumExposureLevel">Maximum exposure level</p>
                    <p i18n="@@overprotectionRisk">Overprotection risk</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <img *ngIf="Evaluation.conformeD === true" class="img-capa" src="assets/images/CAPA_Approved@dpi160.png">
                <img *ngIf="Evaluation.conformeD === false" class="img-capa" src="assets/images/CAPA_Rejected@dpi160.png">
                <div class="centered">
                  <p i18n="@@estimated" style="margin: 0">ESTIMATED</p>
                  <b>{{ Evaluation.psnaD }} dB</b>
                  <p>{{ PAR }}</p>
                </div>
                <div class="row">
                  <div style="text-align: center">
                    <p>{{ Evaluation.picbD }}</p>
                    <p *ngIf="Evaluation.conformeD === true" style="color: green" i18n="@@approved">Approved</p>
                    <p *ngIf="Evaluation.conformeD === false" style="color: red" i18n="@@rejected">Rejected</p>
                    <p>{{ Evaluation.psnaD }} dB</p>
                    <p>{{ ParametreMO.snr }} dB</p>
                    <p>{{ Evaluation.psnaG < Evaluation.psnaD ? Country.lact + Evaluation.psnaG : Country.lact + Evaluation.psnaD }} dB</p>
                    <p>{{ Evaluation.psnaD > ParametreMO.snr + 8 ? 'Oui' : 'Non' }}</p>
                  </div>
                </div>
              </div>
            </div>
<!------------------------- END DESKTOP LAYOUT ---------------------------->








          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="box box-capa">
        <div class="box-header">
          <h3 class="box-title" i18n="@@informations">Informations</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" (click)="informationsOpen = !informationsOpen">
              <i [ngClass]="!informationsOpen ? 'fa fa-plus' : 'fa fa-minus'"></i>
            </button>
          </div>
        </div>
        <div class="box-body" [hidden]="!informationsOpen">
          <p><span i18n="@@capaDocumentation.firstLine">All information on measurement, calculation, overprotection risks, compliance… is available in the "CAPA Technical documentation" document which can be found on the hearingprotech.com website under the "CAPA" section.</span> <br/>
            <span i18n="@@capaDocumentation.secondLine.first">The estimated attenuation corresponds to the </span> {{ PAR }} <span i18n="@@capaDocumentation.secondLine.second">(Personal Attenuation Rating) measured on 3 frequencies with a measurement uncertainty of 5dB.</span><br />
            <span i18n="@@capaDocumentation.thirdLine.first">The maximum exposure level is calculated by adding the </span>{{ PAR }} <span i18n="@@capaDocumentation.thirdLine.second">from the protector whose attenuation is the lowest to the national action value defined according to the legislation in force in the geographical area. This indication takes into account permanent wear throughout the exposure period. </span><br />
            <br />
            <span i18n="@@capaDocumentation.fourthLine">The causes of a non-conformity can be as follows : </span><br />
            <span i18n="@@capaDocumentation.fifth">1 - The protector was incorrectly adjusted during the test, even a small acoustic leak can be enough to significantly degrade its attenuation. It is important that the subject participating in this measurement ensures that his hearing protection is correctly positioned during the control carried out using the diffusion of "pink noise" type noise which is carried out as a preamble to the test.</span><br />
            <span i18n="@@capaDocumentation.six">2 - The protector is a standard cap to be shaped and the user does not know the method to shape it, when this method is not correctly applied, the weakening of this cap can be severely degraded.</span><br />
            <span i18n="@@capaDocumentation.seven">3 - The protector is of the standard preformed or shaped plug type and it is not adapted to the morphology of its user. By definition, being standard, the protector may be too large, in this case the user does not succeed in inserting it, too small, in this case the protector does not fill the entire ear canal or finally not adapted in shape, the external ear canal of the wearer is flat or very bent… It will be necessary to propose a protector adapted to its morphology to allow a good insertion and a perfect waterproofness.</span><br />
            <span i18n="@@capaDocumentation.eight">4 - The protector is of the custom cap type, in this case if the positioning is correct it will be necessary to approach the supplier to ask for its replacement, see its refund.</span><br />
            <br />
            <span i18n="@@capaDocumentation.nine">The causes of overprotection and its consequences can be as follows :</span><br />
            <span i18n="@@capaDocumentation.ten">When certifying this protector, measurements are made on several subjects. Some subjects will have an above-average weakening, others a below-average weakening. These deviations are identified in the standard deviation values reported with the attenuation data.</span><br />
            <span i18n="@@capaDocumentation.eleven">Depending on the morphology of each individual and the reliability of the protector, these differences may be more or less significant.</span><br />
            <span i18n="@@capaDocumentation.twelve">The weakening of a protector may be higher or even much higher than the average, which can, depending on the wearer's environment, be detrimental to his safety, particularly in the case where the latter must perceive warning signals (alarm, machine safety, vehicle movement, warning…).</span><br />
            <span i18n="@@capaDocumentation.thirteen">If the user or his entourage is likely to be endangered because of this inability to perceive his environment correctly, it will be useful or even important to reduce this level of attenuation, either by opting for a lower filter if the protector is equipped with it and if a lower filter exists, or by selecting a protector with a lower attenuation.</span></p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="box box-capa">
        <div class="box-header">
          <h3 class="box-title" i18n="@@otherInformations">Other informations</h3>
        </div>
        <div class="box-body">
          <div class="row" style="padding: 20px">
            <div class="col-sm-6">
              <div class="row info-container">
                <h4 class="header-title" i18n="otherData">Other data</h4>
              </div>
              <div class="row info-container">
                <div class="col-sm-6" style="border-right: solid 2px white;">
                  <h3 style="color: #4cc1d2; text-align: center">{{ TestDuration }}</h3>
                  <p class="header-title" i18n="@@testDuration">Test duration</p>
                </div>
                <div class="col-sm-6">
                  <h3 style="color: #4cc1d2; text-align: center">{{ AverageAnswerAmoutPerFrequency }}</h3>
                  <p class="header-title" i18n="@@AverageAnswerAmoutPerFrequency">Average number of responses per frequency</p>
                </div>
              </div>
              <div class="row info-container">
                <h4 class="header-title" i18n="comments">Comments</h4>
              </div>
              <div class="row info-container" style="height: 352px; padding: 10px;">
                <p style="color: white">{{ Evaluation.commentaires }}</p>
              </div>
              <div class="row info-container">
                <h4 class="header-title"><span i18n="madeWithCAPA">Made with CAPA</span> {{ Evaluation.versionCapa }}</h4>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row info-container">
                <h4 class="header-title" i18n="@@areaOfApplication">Area of application</h4>
              </div>
              <div class="row" style="display: table-cell">
               <img *ngIf="Country.idCountry === 'USA'" alt="" src="assets/images/map-usa.png" style="width: 100%">
               <img *ngIf="Country.idCountry === 'EU'" alt="" src="assets/images/map-europe.png" style="width: 100%">
               <img *ngIf="Country.idCountry === 'AUS'" alt="" src="assets/images/map-aus.png" style="width: 100%">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
